import { render } from "./FolderPlusOutline.vue?vue&type=template&id=4d6301bc"
import script from "./FolderPlusOutline.vue?vue&type=script&lang=js"
export * from "./FolderPlusOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__